<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoPagar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoPagar">
				<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && atualizar()"
				 #f="ngForm" name="form" novalidate >
					<div class="formgroup">
						<div class="flex justify-content-center" *ngIf="loading">
							<p-progressSpinner></p-progressSpinner>
						</div>
						<div *ngIf="messagemVisivel" class="mb-5">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="p-fluid p-formgrid grid" *ngIf="pagamentoDespesa && !loading">
							<div class="field col-12 md:col-3">
								<label htmlFor="planoContaEmpresaId">Especificação</label>
								<input type="text" pInputText name="planoContaEmpresaId" ngModel
									#planoContaEmpresaId="ngModel" [ngModel]="pagamentoDespesa.planoContaEmpresa?.descricao"
									[readOnly]="true"/>
							</div>
	
							<div class="field col-12 md:col-3">
								<label htmlFor="identificacao">Identificação</label>
								<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
									placeholder="Insira a Identificação" name="identificacao" ngModel [readOnly]="true"
									#identificacao="ngModel" [(ngModel)]="pagamentoDespesa.identificacao"/>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="dataVencimento">Vencimento</label>
								<label class="form-control" id="dataVencimento">{{ pagamentoDespesa.dataVencimento | date:'dd/MM/yyyy' }}</label>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="competencia">Competência</label>
									<label class="form-control" id="competencia">{{ pagamentoDespesa.competencia | date: 'MM/yyyy' }}</label>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="valorFluxo">Valor da Despesa</label>
								<p-inputNumber name="valorFluxo" ngModel #valorFluxo="ngModel" mode="currency"
									inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="false"
									[(ngModel)]="pagamentoDespesa.valorFluxo" (ngModelChange)="alterarParcelas(valorFluxo.value)"
									[readonly]="liquidado">
								</p-inputNumber>
								<div *ngIf="valorFluxo.value <= 0" class="alerta">
									<small>O valor não pode ser zero</small>
								</div>
							</div>
							<div class="field col-12 md:col-3">
								<label htmlFor="tipoPagamento">Forma de Pagamento</label>
								<p-dropdown [options]="tiposPagamento" optionLabel="descricao"
									placeholder="Selecione" name="tipoPagamento" ngModel [(ngModel)]="pagamentoDespesa.tipoPagamento"
									#tipoPagamento="ngModel" [filter]="true" [required]="true" [readonly]="liquidado">
								</p-dropdown>
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="dataFluxo">Data do Pagamento</label>
								<p-calendar
									*ngIf="!liquidado"
									[readonlyInput]="true"
									[showIcon]="true"
									dateFormat="dd/mm/yy"
									[showButtonBar]="true"
									name="dataFluxo" ngModel
									#dataFluxo="ngModel" [(ngModel)]="pagamentoDespesa.dataFluxo"
									(ngModelChange)="selecionarData(dataFluxo.value)">
								</p-calendar>
								<label *ngIf="liquidado" class="form-control" id="dataVencimento">{{ pagamentoDespesa.dataFluxo | date:'dd/MM/yyyy' }}</label>
							</div>
	
						</div>
						<div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!loading">
							<div class="col-12 md:col-4">
								<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
									type="submit" pButton icon="pi pi-check" label="Pagar"
										class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid || (pagamentoDespesa?.valorFluxo ?? 0) <= 0
										|| pagamentoDespesa?.status === 1">
								</button>
								<ng-template #exibirBotaoFalso>
									<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Pagar"
									class="p-button-outlined p-button-success md:w-9rem" disabled></button>
								</ng-template>
							</div>
							<div class="col-12 md:col-4 flex justify-content-end">
								<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
									class="p-button-outlined md:w-9rem" routerLink="/apps/pagamento-despesa"></button>
							</div>
						</div>
						</div>
				</form>
				<p-confirmDialog [style]="{width: '50vw'}">
				</p-confirmDialog>
			</div>
		</div>
	</div>
	